import React, { useState, useEffect } from "react";
import { useParams } from "@reach/router";
import Footer from "../components/footer";
import { createGlobalStyle } from "styled-components";
import axios from "axios";
import { utils } from "ethers";
import { useContractFunction } from "@usedapp/core";
import { useContractContext } from "../../hooks/useContractContext";

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #FAF6F1;
    border-bottom: solid 1px #ccc !important;
  }
`;

const ManageRecord = () => {
  const {
    copyrightsContract,
    marketplaceContract,
    licensesContract,
    contractAddr,
  } = useContractContext();
  const params = useParams();
  const tokenId = params.tokenId;

  const [license1Price, setLicense1Price] = useState();
  const [newPrice, setNewPrice] = useState();
  const [updatedPrice, setUpdatedPrice] = useState();

  const [ETHSGD, setETHSGD] = useState();
  const [metaData, setMetaData] = useState();
  const [detailsOfWork, setDetailsOfWork] = useState({
    creatorPseudonym: "",
    typeOfWork: "",
    yearCreated: "",
    workIpfsCid: "",
  });
  const [saleItem, setSaleItem] = useState({
    itemId: "",
    NFTContract: "",
    tokenId: "",
    seller: "",
    price: null,
    forSale: null,
  });

  useEffect(() => {
    const fetchData = async () => {
      setETHSGD(
        (
          await axios.get(
            "https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=SGD"
          )
        ).data.SGD
      );
      setDetailsOfWork(await copyrightsContract.checkDetailsOfWork(tokenId));
      const ipfsUri = await copyrightsContract.tokenURI(tokenId);
      const formattedUri = formatIpfsUrl(ipfsUri);
      setMetaData((await axios.get(formattedUri)).data);
      setSaleItem(
        await marketplaceContract.getMarketItem(
          copyrightsContract.address,
          tokenId
        )
      );
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { state: setProductTemplateState, send: sendSetProductTemplate } =
    useContractFunction(licensesContract, "setProductTemplate");
  const { state: createMarketItemState, send: sendCreateMarketItem } =
    useContractFunction(marketplaceContract, "createMarketItem");
  const { state: changeSaleStatusState, send: sendChangeSaleStatus } =
    useContractFunction(marketplaceContract, "changeSaleStatus");
  const { state: updateSalesPriceState, send: sendUpdateSalesPrice } =
    useContractFunction(marketplaceContract, "updateSalesPrice");
  const { state: approveState, send: sendApprove } = useContractFunction(
    marketplaceContract,
    "approve"
  );

  const updateLicensePrice = async (licensePrice, configNum) => {
    setProductTemplateState.status = "Mining";
    let saleSGDPrice = licensePrice;
    const EthereumPrice = (saleSGDPrice / ETHSGD).toFixed(18);
    sendSetProductTemplate(
      utils.parseEther(EthereumPrice),
      contractAddr.copyrights,
      tokenId,
      configNum
    );
  };

  const handleCreateSaleItem = async () => {
    if (
      (await copyrightsContract.getApproved(tokenId)) !==
      contractAddr.marketplace
    ) {
      await sendApprove(contractAddr.marketplace, tokenId);
    }
    createMarketItemState.status = "Mining";
    let saleSGDPrice = newPrice;
    const EthereumPrice = (saleSGDPrice / ETHSGD).toString();
    (
      await sendCreateMarketItem(
        contractAddr.copyrights,
        tokenId,
        utils.parseEther(EthereumPrice)
      )
    ).wait();
    getSaleItemDetails();
  };

  const updateSalesPrice = async () => {
    updateSalesPriceState.status = "Mining";
    let saleSGDPrice = updatedPrice;
    const EthereumPrice = (saleSGDPrice / ETHSGD).toString();
    await sendUpdateSalesPrice(
      contractAddr.copyrights,
      tokenId,
      utils.parseEther(EthereumPrice)
    );
    getSaleItemDetails();
  };

  const removeSalesItem = async () => {
    changeSaleStatusState.status = "Mining";
    await sendChangeSaleStatus(contractAddr.copyrights, tokenId, false);
    let zeroAddress = "0x0000000000000000000000000000000000000000";
    await sendApprove(zeroAddress, tokenId);
    getSaleItemDetails();
  };

  const formatIpfsUrl = (url) => {
    return url.replace(/ipfs:\/\//g, "https://nftstorage.link/");
  };

  const [openMenu, setOpenMenu] = useState(true);
  const [openMenu1, setOpenMenu1] = useState(false);

  const handleBtnClick = () => {
    setOpenMenu(!openMenu);
    setOpenMenu1(false);

    document.getElementById("Mainbtn").classList.add("active");
    document.getElementById("Mainbtn1").classList.remove("active");
  };

  const handleBtnClick1 = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu(false);

    document.getElementById("Mainbtn1").classList.add("active");
    document.getElementById("Mainbtn").classList.remove("active");
  };

  const getSaleItemDetails = async () => {};

  const newPriceChangeHandler = (event) => {
    setNewPrice(event.target.value);
  };
  const updatedPriceChangeHandler = (event) => {
    setUpdatedPrice(event.target.value);
  };
  const license1PriceChangeHandler = (event) => {
    setLicense1Price(event.target.value);
  };
  // const license2PriceChangeHandler = (event) => {
  //   setLicense2Price(event.target.value);
  // };

  return (
    <div>
      <GlobalStyles />

      <section className="container">
        <div className="row mt-md-5 pt-md-4">
          <div className="col-md-6 text-center">
            <img
              src={formatIpfsUrl(detailsOfWork.workIpfsCid)}
              className="img-fluid img-rounded mb-sm-30"
              alt=""
            />
          </div>
          <div className="col-md-6">
            <div className="item_info">
              <h2>{metaData === undefined ? "fetching" : metaData.title}</h2>
              <div className="item_info_counts">
                {detailsOfWork.typeOfWork === "Artistic" && (
                  <div className="item_info_type">
                    <i className="fa fa-image"></i>Artistic, Image
                  </div>
                )}
                {detailsOfWork.typeOfWork !== "Artistic" && (
                  <div className="item_info_type">
                    {detailsOfWork.typeOfWork}
                  </div>
                )}
              </div>
              <p>
                {metaData === undefined ? "fetching" : metaData.description}
              </p>
              <h4>Creator</h4>
              <div className="item_author">
                <div className>
                  <span>{detailsOfWork.creatorPseudonym}</span>
                </div>
              </div>
              <div className="spacer-20"></div>
              <div className="de_tab">
                <ul className="de_nav">
                  <li id="Mainbtn" className="active">
                    <span onClick={handleBtnClick}>Licenses</span>
                  </li>
                  <li id="Mainbtn1">
                    <span onClick={handleBtnClick1}>Sell Copyright</span>
                  </li>
                </ul>

                <div className="de_tab_content">
                  {openMenu && (
                    <div className="tab-2 onStep fadeIn">
                      <h5>Licenses</h5>
                      <div>
                        <span>
                          Permissions given by the copyright holder for their
                          content. Licenses can be applied to copyrighted
                          material to give permission for certain uses of the
                          material.
                        </span>
                      </div>
                      <div className="spacer-20"></div>
                      <div className="nft__item_price row-eq-height">
                        <h6>Default License configuration</h6>
                        Duration (365 days)
                        <button
                          className="btn-main p-2"
                          onClick={() => updateLicensePrice(license1Price, 0)}
                          disabled={setProductTemplateState.status === "Mining"}
                        >
                          create / update config
                        </button>
                        <br />
                        Price (SGD <i className="fa fa-dollar" />) :{" "}
                        <input onChange={license1PriceChangeHandler}></input>
                        {license1Price && (
                          <div>
                            <div className="spacer-10" />
                            <div className="tab-2 onStep fadeIn">
                              Copycats Fee (30%) :{" "}
                              {license1Price &&
                                (license1Price * 0.3).toFixed(2)}
                            </div>
                            <div className="tab-2 onStep fadeIn">
                              Artist Receives (70%) :{" "}
                              {license1Price &&
                                (license1Price * 0.7).toFixed(2)}
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="spacer-20"></div>
                      <div className="nft__item_price row-eq-height">
                        <h6>Custom License configuration</h6> work in progress
                        {/* <br />
                        Duration (days) : <input onChange={license2PriceChangeHandler}></input>
                        <br />
                        Contract (days) : <input onChange={license2PriceChangeHandler}></input>
                        <span className="btn-main p-2" onClick={() => updateLicensePrice(license2Price, 2)}>
                          create / update config
                        </span>
                        <br />
                        Price (SGD <i className="fa fa-dollar" />) :{" "}
                        <input onChange={license2PriceChangeHandler}></input> */}
                        <div className="spacer-10"></div>
                      </div>
                      <div className="spacer-20"></div>
                    </div>
                  )}

                  {openMenu1 && (
                    <div className="tab-2 onStep fadeIn">
                      <h5>Warning</h5>
                      Copyright can only be 'assigned' (sold or given away) by
                      the execution of a written document signed by the
                      copyright owner. It is not advisable, however, to assign
                      or otherwise dispose of your copyright over your works.
                      <div className="spacer-20"></div>
                      {saleItem.forSale === false && (
                        <div className="nft__item_price row-eq-height">
                          Price (SGD):{" "}
                          <input onChange={newPriceChangeHandler}></input>
                          <button
                            className="btn-main inline p-1"
                            onClick={() => handleCreateSaleItem()}
                            disabled={
                              createMarketItemState.status === "Mining" ||
                              approveState.status === "Mining"
                            }
                          >
                            put up for sale
                          </button>
                          <div className="spacer-20" />
                          {newPrice && (
                            <div>
                              <div className="tab-2 onStep fadeIn">
                                Copycats Fee (30%) :{" "}
                                {newPrice && (newPrice * 0.3).toFixed(2)}
                              </div>
                              <div className="tab-2 onStep fadeIn">
                                Artist Receives (70%) :{" "}
                                {newPrice && (newPrice * 0.7).toFixed(2)}
                              </div>
                            </div>
                          )}
                          {approveState.status === "Mining" &&
                            "Approving marketPlace"}
                          {createMarketItemState.status === "Mining" &&
                            "creating Market Item"}
                        </div>
                      )}
                      {saleItem.forSale === true && (
                        <div className="nft__item_price row-eq-height">
                          Current Price :{" "}
                          {saleItem.price === null
                            ? ""
                            : (utils.formatEther(saleItem.price) * 1).toFixed(
                                4
                              )}{" "}
                          ETH ={" "}
                          {saleItem.price === null
                            ? ""
                            : (
                                utils.formatEther(saleItem.price) * ETHSGD
                              ).toFixed(2)}{" "}
                          SGD
                          <div className="spacer-10"></div>
                          <b>
                            Set New Price (SGD <i className="fa fa-dollar" />){" "}
                          </b>
                          <input onChange={updatedPriceChangeHandler}></input>
                          <button
                            className="btn-main inline p-1"
                            onClick={() => updateSalesPrice()}
                            disabled={changeSaleStatusState.status === "Mining" || updateSalesPriceState.status === "Mining"}
                          >
                            update price
                          </button>
                          {updateSalesPriceState.status === "Mining" &&
                            "Loading..."}
                          {updatedPrice && (
                            <div>
                              <div className="tab-2 onStep fadeIn">
                                Copycats Fee (30%) :{" "}
                                {updatedPrice &&
                                  (updatedPrice * 0.3).toFixed(2)}
                              </div>
                              <div className="tab-2 onStep fadeIn">
                                Artist Receives (70%) :{" "}
                                {updatedPrice &&
                                  (updatedPrice * 0.7).toFixed(2)}
                              </div>
                              <br />
                            </div>
                          )}
                          <div className="spacer-30"></div>
                          <button
                            className="btn-main inline p-1"
                            onClick={() => removeSalesItem()}
                            disabled={changeSaleStatusState.status === "Mining" || updateSalesPriceState.status === "Mining"}
                          >
                            Remove item from marketplace
                          </button>
                          {saleItem.forSale === true &&
                            changeSaleStatusState.status === "Mining" &&
                            "Removing Sales Item... Please wait to remove market approval via wallet"}
                          {saleItem.forSale === true &&
                            approveState.status === "Mining" &&
                            "Removing MarketPlace Approval... please accept transaction on your wallet"}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
export default ManageRecord;
